import { converge, pipe, pick, values, toLower, path, pathOr, map, reduce, concat } from 'ramda'
import { getFinancedAccessoryGroups, getFinancedAccessoryPenalties } from '../../../utils/mobility'

export const getCartProvince = (cart) => toLower(path(['root', 'province'], cart))

export const getCartLanguage = (cart) => toLower(path(['root', 'language'], cart))

export const getTopLevelInvalidCartItems = (cart) => {
  const validationErrors = pathOr([], ['root', 'validationErrors'], cart)
  const invalidItems = pipe(
    map((e) => e.items),
    reduce(concat, [])
  )(validationErrors)
  const cartWithInvalidItems = { ...cart, invalidItems }
  return converge(pipe(pick, values), [path(['invalidItems']), path(['items'])])(
    cartWithInvalidItems
  )
}

export const shouldShowRemainingAFBalanceReminder = (cart) => {
  return getFinancedAccessoryGroups(cart).some(
    (group) => getFinancedAccessoryPenalties(group)?.length > 0
  )
}

export const parsePersonalizationApiError = (error) => {
  try {
    // config object is only present for parsed http axios errors
    const isAxiosHTTPError = !!error.config

    if (!isAxiosHTTPError) {
      const parsedError = JSON.parse(error.message)
      const mappedErrorObject = {
        status: parsedError.status,
        data: {
          error: error.name,
          message: parsedError.message
        }
      }
      return mappedErrorObject
    }

    const mappedErrorObject = {
      status: error.code,
      data: {
        error: error.name,
        message: error.message
      }
    }
    return mappedErrorObject
  } catch (err) {
    return {
      data: {
        error: error.message,
        message: 'Parse Personalization Api Error'
      }
    }
  }
}
